import { FilePdfIcon, FileDocIcon, FileTxtIcon, FileExcelIcon, VideoIcon } from 'sharedComponents/Icons';
import { EXTENSION_TYPES, FILE_TYPES } from 'constants/index';
import { parse } from 'url';

export const extensionRegexp = /(?:\.([^.]+))?$/; //gets media file extension type

export const getAttachmentsIcon = (resourceType = '', inboundFileExt) => {
  const isInboundVideoIcon = ['mov', 'mpeg', '3gpp', '3gp', 'mp4'].includes(inboundFileExt);
  if (resourceType === 'raw' || inboundFileExt === 'pdf') return FilePdfIcon;
  if (resourceType === 'video' || isInboundVideoIcon) return VideoIcon;
};

export const getFileIconByType = (fileType = '') => {
  switch (fileType) {
    case FILE_TYPES.PDF:
      return FilePdfIcon;

    case FILE_TYPES.DOC:
    case FILE_TYPES.DOCX:
      return FileDocIcon;

    case FILE_TYPES.XLX:
    case FILE_TYPES.XLSX:
      return FileExcelIcon;

    case FILE_TYPES.TXT:
      return FileTxtIcon;

    default:
      return undefined;
  }
};

export const getFileExtension = (url = '') =>
  parse(url)
    .pathname?.split('.')
    ?.pop()
    .toLowerCase();

export const getFileIconByUrl = (fileUrl) => {
  const extension = getFileExtension(fileUrl);
  switch (extension) {
    case EXTENSION_TYPES.PDF:
      return FilePdfIcon;

    case EXTENSION_TYPES.DOC:
    case EXTENSION_TYPES.DOCX:
      return FileDocIcon;

    case EXTENSION_TYPES.XLX:
    case EXTENSION_TYPES.XLSX:
      return FileExcelIcon;

    case EXTENSION_TYPES.TXT:
      return FileTxtIcon;

    default:
      return undefined;
  }
};

export const getFileNameFromUrl = (url = '') => {
  const name = parse(url)
    .pathname?.split('/')
    ?.pop();
  return name && unescape(name);
};
